import { ContentCard } from "@/types/cms";

/** Defensive price-relation read — same nesting tolerance as cardPrice.tsx
 *  (normalizePayload usually flattens, but older shapes nest attributes).
 *  Used by the gift PDP (GiftForm) and productCardHorizontal callers. */
export function readPriceAttrs(card: ContentCard): Record<string, unknown> | null {
  const rawPrice = card.price as
    | { data?: { attributes?: Record<string, unknown> }; attributes?: Record<string, unknown> }
    | Record<string, unknown>
    | null
    | undefined;
  return (
    (rawPrice as { data?: { attributes?: Record<string, unknown> } })?.data?.attributes ??
    (rawPrice as { attributes?: Record<string, unknown> })?.attributes ??
    (rawPrice as Record<string, unknown>) ??
    null
  );
}
